import styled, { css } from 'styled-components';
import { Flexbox, Text, ClearButton } from '@morressier/ts';
import { LinkButton } from '../Button';

// DatePickerInput styles
export const InputContainer = styled(Flexbox)<{
  disabled?: boolean;
  error?: string;
}>`
  border: 1px solid
    ${({ error }) => (error ? 'var(--color-red-50)' : 'var(--color-mono-60)')};
  color: var(--color-mono-60);
  border-radius: 4px;
  padding: 8px;
  width: 10rem;
  background-color: ${({ disabled }) =>
    disabled ? 'var(--color-mono-95)' : 'var(--color-mono-100)'};

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover,
      &:focus {
        border: 1px solid var(--color-mono-0);
        color: var(--color-mono-0);
      }
      &:focus-within,
      &:focus {
        outline: var(--focus-style);
        outline-offset: 2px;
      }
    `}
`;

export const Placeholder = styled(Text)`
  display: inline;
  color: inherit;
`;
export const Input = styled.input<{ width?: number }>`
  border: none;
  width: ${({ width }) => width || 20}px;
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  &:focus {
    outline: none;
    background-color: var(--color-mono-95);
  }
  &::selection {
    background: none;
  }
`;

export const CalenderButton = styled(ClearButton)`
  border-radius: 0.25rem;
`;

// MonthPicker styles
export const List = styled.div<{
  isOpen: boolean;
  placement?: 'top' | 'bottom';
}>`
  position: absolute;
  z-index: 1;
  width: 19.5rem;
  ${({ placement }) =>
    placement === 'bottom' &&
    css`
      bottom: 48px;
    `}

  background-color: var(--color-mono-100);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.24);
  border-radius: 8px;
  padding: 1rem;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

export const Container = styled.div`
  position: relative;
`;

export const MonthPickerContainer = styled(Flexbox)`
  margin: 0 auto 0.5rem auto;
`;

export const ArrowButton = styled(LinkButton)<{ gutterBottom?: boolean }>`
  padding: 4px 5px;
  ${({ gutterBottom }) =>
    gutterBottom &&
    css`
      margin-bottom: 8px;
    `}
`;

export const Item = styled(Text).attrs((props: { isSelected?: boolean }) => ({
  fontWeight: 'medium',
  ...props
}))`
  padding: 8px;
  cursor: pointer;
  text-align: center;
  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: var(--color-yellow-60);
      border-radius: 4px;
    `};
`;
